import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { BlogEntry } from "./blog-entry";
import { BlogBackendService } from "./blog-backend.service";

@Injectable({
  providedIn: 'root'
})
export class BlogEntryStore {
  private entry$: BehaviorSubject<BlogEntry[]> = new BehaviorSubject([])

  constructor(private blogBackend: BlogBackendService)
  {
    this.loadInitialData();
  }

  public get entries(): Observable<BlogEntry[]> {
    return this.entry$.asObservable();
  }

  private loadInitialData(): void {
    this.blogBackend.getAllEntries()
      .subscribe(v => this.entry$.next(v));
  }
}
